import { render, staticRenderFns } from "./NeedGlass.vue?vue&type=template&id=aa2be572&"
import script from "./NeedGlass.vue?vue&type=script&lang=ts&"
export * from "./NeedGlass.vue?vue&type=script&lang=ts&"
import style0 from "./NeedGlass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports